import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Hash} from "../../model/hash";
import { SousTitreBlocComponent } from '../sous-titre-bloc/sous-titre-bloc.component';
import { ButtonToggleGroupComponent } from '../button-toggle-group/button-toggle-group.component';
import { MatButtonToggleGroup, MatButtonToggle } from '@angular/material/button-toggle';
import { TranslocoModule } from '@ngneat/transloco';

export interface changeHashEvent {
  hash: Hash
}

@Component({
    selector: 'app-select-hash',
    templateUrl: './select-hash.component.html',
    styleUrls: ['./select-hash.component.scss'],
    imports: [SousTitreBlocComponent, ButtonToggleGroupComponent, MatButtonToggleGroup, MatButtonToggle, TranslocoModule]
})
export class SelectHashComponent {
  @Input() initialHash = ''
  @Output() changeHash: EventEmitter<changeHashEvent> = new EventEmitter<changeHashEvent>();

  selectHash(hash: Hash) {
    this.changeHash.emit({hash})
  }

  protected readonly Hash = Hash;
}
